import { Link, useLocation } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { founder, salon } from '../../data/content';
import { adminOnlySections, adminSections } from '../../data/adminSections';
import { shopLabels } from '../../data/shopLabels';
import { adminHref } from '../../utils/hosts';
import { btnPrimary, btnSecondary } from '../../ui/styles';
import { closingHeading } from '../../ui/sections';
type Props = {
  title?: string;
  body?: string;
  /** Waar 'terug' naartoe leidt. */
  backTo?: {
    to: string;
    label: string;
  };
};

/** Eén 'niet gevonden'-pagina voor onbekende adressen, producten, artikelen en juridische teksten. */
export function NotFound(props: Props) {
  const {
    pathname
  } = useLocation();
  // Iemand typt /marketing of /klanten: dat staat in het beheer (op /be).
  const path = pathname.replace(/\/$/, '');
  const adminKey = props.backTo ? undefined : adminOnlySections.find(k => adminSections[k].path === path);
  const adminItem = adminKey ? adminSections[adminKey] : undefined;
  const {
    title = adminItem ? `${adminItem.label} staat in het beheer` : 'Deze pagina bestaat niet (meer)',
    body = adminItem ? 'Dit onderdeel is alleen voor de salon en vraagt om in te loggen in het beheer.' : 'Misschien is de link veranderd of verlopen. Begin opnieuw op de homepage of in de webshop, of app me even: ik wijs je de weg.',
    backTo = {
      to: '/',
      label: 'Naar de homepage'
    }
  } = props;
  return <section className="mx-auto flex w-full max-w-content flex-col items-center px-6 py-28 text-center lg:px-10 lg:py-36" aria-labelledby="not-found-title" data-id="element-8186" data-mp="d4qwsvreeyn5">
      {/* "404" is sfeer; de kop zegt al wat er aan de hand is. */}
      <p className="type-figure text-clay" aria-hidden="true" data-id="element-8187" data-mp="83kz0jivsl6r">
        404
      </p>
      <h1 id="not-found-title" className={`mt-6 max-w-lg ${closingHeading} text-ink`} data-id="element-8188" data-mp="85e968spdnji">
        {title}
      </h1>
      <p className="mt-4 max-w-md text-[17px] leading-relaxed text-muted" data-id="element-8189" data-mp="22hm2jhpdlwd6">{body}</p>
      <div className="mt-9 flex flex-wrap justify-center gap-3" data-id="element-8190" data-mp="22f855278482g">
        {adminItem ?
      // Een gewone link: het beheer is een los deel (en straks een ander domein).
      <a href={adminHref(adminItem.path)} className={btnPrimary} data-id="element-8191" data-mp="1w00xaak8qxv4">
            Naar het beheer
          </a> : <Link to={backTo.to} className={btnPrimary} data-id="element-8192" data-mp="1n0nn1foam59c">
            {backTo.label}
          </Link>}
        {backTo.to !== '/webshop' && <Link to="/webshop" className={btnSecondary} data-id="element-8193" data-mp="2jplil03va77k">
            Webshop
          </Link>}
        <a href={salon.whatsapp} target="_blank" rel="noopener noreferrer" className={btnSecondary} data-id="element-8194" data-mp="2et4vm98elyw2">
          <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-8195" data-mp="29zshit1cpahk" />
          Vraag het {founder.firstName}
          <span className="sr-only" data-id="element-8196" data-mp="25xfdqa65zmnf">{shopLabels.viaWhatsApp}</span>
        </a>
      </div>
    </section>;
}